<div class="p-fluid p-formgrid grid mt-5">
    <div class="field col-12 md:col-6  -mb-4">
        <div class="p-fluid">
            <h5>Ubicación</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                      <span class="p-float-label">
                          <input id="matricula" #matriculaInput
                                 type="text"
                                 pInputText
                                 tooltipPosition="top"
                                 [pTooltip]="draftProjectService.draftProject().ubicacionItem.matricula?'':'Ingresar matricula'"
                                 (keyup)="setUbicacionItemMatricula(matriculaInput.value)"
                                 [(ngModel)]="draftProjectService.draftProject().ubicacionItem.matricula"/>
                          <label for="matricula">Matricula</label>
                      </span>
                </div>
                <div class="field col">
                       <span class="p-float-label">
                          <input id="claveCatastral" #claveCatastralInput
                                 type="text"
                                 pInputText
                                 tooltipPosition="top"
                                 [pTooltip]="draftProjectService.draftProject().ubicacionItem.claveCatastral?'':'Ingresar clave catastral'"
                                 (keyup)="setUbicacionItemClaveCatastral(claveCatastralInput.value)"
                                 [(ngModel)]="draftProjectService.draftProject().ubicacionItem.claveCatastral"/>
                          <label for="claveCatastral">Clave catastral</label>
                      </span>
                </div>
            </div>
        </div>
    </div>
    <div class="field col-12 md:col-6  -mb-4">
        <div class="p-fluid">
            <h5>Coordenadas</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                 <span class="p-float-label">
                          <input id="latitud" #latitudInput
                                 type="number"
                                 step="any"
                                 pInputText
                                 tooltipPosition="top"
                                 [pTooltip]="draftProjectService.draftProject().ubicacionItem.latitud?'':'Ingresar Latitud'"
                                 (keyup)="setUbicacionItemLatitud(latitudInput.value)"
                                 [(ngModel)]="draftProjectService.draftProject().ubicacionItem.latitud"
                                 [disabled]="true"/>
                          <label for="latitud">Latitud</label>
                      </span>
                </div>
                <div class="field col">
                          <span class="p-float-label">
                          <input id="longitud" #longitudInput
                                 type="number"
                                 step="any"
                                 pInputText
                                 tooltipPosition="top"
                                 [pTooltip]="draftProjectService.draftProject().ubicacionItem.longitud?'':'Ingresar longitud'"
                                 (keyup)="setUbicacionItemLongitud(longitudInput.value)"
                                 [(ngModel)]="draftProjectService.draftProject().ubicacionItem.longitud"
                                 [disabled]="true"/>
                          <label for="longitud">Longitud</label>
                      </span>
                </div>
                <div class="field col-1">
                    <button (click)="viewLeafletMap()" pButton
                            class="w-3rem h-3rem flex align-items-center justify-content-center"
                            pTooltip="Seleccionar coordenadas" [rounded]="true" [outlined]="true">
                        <img src="assets/demo/images/logos/iconos/map_marker_icon.png" alt="icon-map" width="31" height="31">
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="field col-12 -mb-4">
        <h5>Dirección</h5>
    </div>
    <div class="field col-12 md:col-6">
        <span class="p-float-label">
        <input id="calleAvenida" #calleAvenidaInput required
               [(ngModel)]="draftProjectService.draftProject().direccion.complemento"
               [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().direccion.complemento}"
               type="text"
               pInputText
               (keydown)="isCharactersValid($event,3)"
               [pTooltip]="draftProjectService.draftProject().direccion.complemento?'':'Ingresar calle o avenida'"
               tooltipPosition="top"/>
            <label for="calleAvenida">Calle/Avenida <small style="color:red"><b>*</b></small></label>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().direccion.complemento"><b>Favor
                ingresar la calle o avenida</b></small>
        </span>

    </div>
    <div class="field col-12 md:col-6">
        <span class="p-float-label">
        <input #coloniaCantonInput required [(ngModel)]="draftProjectService.draftProject().direccion.complemento2"
               [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().direccion.complemento2}"
               id="coloniaCanton"
               pInputText (keydown)="isCharactersValid($event,3)"
               [pTooltip]="draftProjectService.draftProject().direccion.complemento2?'':'Ingresar colonia o cantón'"
               tooltipPosition="top"/>
            <label for="coloniaCanton">Colonia/Cantón <small style="color:red"><b>*</b></small></label>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().direccion.complemento2"><b>Favor
                ingresar la colonia o cantón</b></small>
        </span>

    </div>
    <div class="field col-12 md:col-3">
        <p-dropdown [(ngModel)]="draftProjectService.draftProject().departamento" [options]="departamentos"
                    optionLabel="descripcion"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="descripcion"
                    [showClear]="true" (onChange)="setDepartamento($event.value)" id="departamento" [required]="true"
                    [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().departamento.id}"
                    placeholder="Seleccione su departamento *"
                    [pTooltip]="draftProjectService.draftProject().departamento.id?'':'Seleccione su departamento'"
                    tooltipPosition="top"></p-dropdown>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !this.draftProjectService.draftProject().departamento.id"><b>Favor
            seleccione
            un departamento</b></small>
    </div>
    <div class="field col-12 md:col-3">
        <p-dropdown [(ngModel)]="draftProjectService.draftProject().distrito" id="distrito"
                    (onChange)="setDistrito($event.value)" [options]=" distritos"
                    [required]="true"
                    [disabled]="distritos.length==0" optionLabel="descripcion" [showClear]="true"
                    [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().distrito.idDistrito}"
                    placeholder="Seleccione su municipio *"
                    [pTooltip]="draftProjectService.draftProject().distrito.idDistrito?'':'Seleccione su municipio'"
                    tooltipPosition="top"></p-dropdown>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().distrito.idDistrito"><b>Favor seleccione
            un municpio</b></small>
    </div>
    <div class="field col-12 md:col-3">
        <p-dropdown [(ngModel)]="draftProjectService.draftProject().direccion.idMunicipio" id="municipio"
                    [options]="municipios" [required]="true"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="descripcion" optionValue="idMunicipio"
                    [disabled]="municipios.length==0" optionLabel="descripcion"
                    [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().direccion.idMunicipio}"
                    [showClear]="true"
                    placeholder="Seleccione su distrito *"
                    [pTooltip]="draftProjectService.draftProject().direccion.idMunicipio?'':'Seleccione su distrito'"
                    tooltipPosition="top"></p-dropdown>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().direccion.idMunicipio"><b>Favor seleccione
            un distrito</b></small>
    </div>
    <div class="field col-12 md:col-3">
        <span class="p-float-label">
            <input #areaTerrenoInput required [(ngModel)]="datosProyecto.areaTerreno"
                   [ngClass]="{'ng-invalid ng-dirty' : (camposCompletos && !datosProyecto.areaTerreno) || datosProyecto.areaTerreno=='0'}"
                   id="area" pInputText
                   (keydown)="isNumericValid($event)" (keyup)="setArreaTerreno(datosProyecto.areaTerreno)"
                   [pTooltip]="datosProyecto.areaTerreno?'':'Ingresar área del inmueble'" tooltipPosition="top"/>
                <label for="area">Área de inmueble en m²<small style="color:red"><b>*</b></small></label>
        </span>
        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="(camposCompletos && !datosProyecto.areaTerreno)"><b>Favor
            ingresar área de inmueble</b></small>
        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="datosProyecto.areaTerreno=='0'"><b>Favor
            ingresar una área de inmueble válida</b></small>
    </div>
</div>
<div class="p-fluid p-formgrid grid">
    <div class="field col-12 -mb-5">
        <h5>Características del terreno</h5>
    </div>
    <div class="field col-12 md:col-4">
        <p-multiSelect [(ngModel)]="this.draftProjectService.draftProject().elementosTerreno!"
                       (onChange)="setElementoTerreno(this.draftProjectService.draftProject().elementosTerreno!)"
                       [options]="elementosTerrenos" optionLabel="descripcion"
                       [required]="true"
                       [showClear]="true"
                       [filter]="true"
                       [ngClass]="{'ng-invalid ng-dirty' : camposCompletos &&  (!draftProjectService.draftProject().elementosTerreno || draftProjectService.draftProject().elementosTerreno.length===0)}"
                       placeholder="Seleccione elementos del terreno *"
                       filterBy="descripcion"
                       [pTooltip]="this.draftProjectService.draftProject().elementosTerreno===null?'':'Seleccione uno o varios elementos del terreno'"
                       tooltipPosition="top"></p-multiSelect>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && (!draftProjectService.draftProject().elementosTerreno || draftProjectService.draftProject().elementosTerreno.length===0)"><b>
            Favor seleccione uno o varios elementos del terreno</b></small>
    </div>
    <div class="field col-12 md:col-4">
        <p-dropdown [(ngModel)]="draftProjectService.draftProject().idCobertura" id="coberturaVegetal"
                    (onChange)="setCobertura(draftProjectService.draftProject().idCobertura!)"
                    [options]="coberturasVegetal" optionLabel="descripcion"
                    [required]="true"
                    [showClear]="true"
                    [checkmark]="true"
                    [filter]="true"
                    [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().idCobertura}"
                    filterBy="descripcion" optionValue="id"
                    placeholder="Seleccione una cobertura vegetal *"
                    [pTooltip]="draftProjectService.draftProject().idCobertura?'':'Seleccione una cobertura vegetal'"
                    tooltipPosition="top"></p-dropdown>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().idCobertura"><b>Favor seleccione una cobertura
            vegetal</b></small>
    </div>
    <div class="field col-12 md:col-4">
        <p-dropdown [(ngModel)]="draftProjectService.draftProject().idRelieve"
                    (onChange)="setRelieve(draftProjectService.draftProject().idRelieve!)"
                    [required]="true"
                    [showClear]="true"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="descripcion" optionValue="id"
                    [ngClass]="{'ng-invalid ng-dirty' : camposCompletos && !draftProjectService.draftProject().idRelieve}"
                    id="relieve"
                    [options]="relieves"
                    optionLabel="descripcion" placeholder="Seleccione un relieve *"
                    [pTooltip]="draftProjectService.draftProject().idRelieve?'':'Seleccione un relieve'"
                    tooltipPosition="top"></p-dropdown>
        <small style="color:red" class="ng-dirty ng-invalid"
               *ngIf="camposCompletos && !draftProjectService.draftProject().idRelieve"><b>Favor seleccione
            relieve</b></small>
    </div>
</div>
<div class="p-fluid p-formgrid grid">
    <div class="field col-12 -mb-5">
        <h5>Colindantes (Opcional)</h5>
    </div>
    <div class="field col-12 md:col-4">
        <p-dropdown [ngModel]="ubicacionSeleccionada" id="ubicacionColindante" [options]="opcionesUbicacion"
                    [(ngModel)]="ubicacionSeleccionada" optionLabel="descripcion" [showClear]="true"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="descripcion"
                    placeholder="Seleccione la ubicación"
                    [pTooltip]="ubicacionSeleccionada?'':'Seleccione la ubicación'" tooltipPosition="top"></p-dropdown>
    </div>
    <div class="field col-12 md:col-4">
        <input [value]="nombreColindante" #inputNombreColindante
               (keyup)="nombreColindante = inputNombreColindante.value" placeholder="Ingrese el nombre de su colindante"
               id="nombreProyecto" pInputText (keydown)="isCharactersValid($event,4)"
               [pTooltip]="nombreColindante?'':'Ingresar nombre de su colindante'"
               tooltipPosition="top"/>
    </div>
    <div class="field col-12 md:col-4">
        <button (click)="agregarColindante()" pButton icon="pi pi-plus"
                pTooltip="Agregar colindante"></button>
    </div>
    <div class="field col-12">
        <p-table columnResizeMode="expand" [value]="this.draftProjectService.draftProject().colindantes!" [paginator]="true"
                 styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                 [tableStyle]="{ 'min-width': '50rem' }"
                 currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Colindantes"
                 [rowsPerPageOptions]="[5, 10, 25, 50]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:25%">Nombre</th>
                    <th style="width:25%">Ubicación</th>
                    <th style="width:25%">Operación</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-proyecto let-index="rowIndex">
                <tr>
                    <td>
                        {{ proyecto.nombreColindante }}
                    </td>
                    <td>
                        {{ proyecto.ubicacion }}
                    </td>
                    <td>
                        <p-button (onClick)="eliminarColindante(index)" pTooltip="Eliminar colindante"
                                  icon="pi pi-trash"
                                  styleClass="p-button-rounded p-button-danger p-button-text"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<!--Dialog para visualizar el mapa-->
<ng-container>
<app-leaflet-map [dialogLeafletView]="onpenLeaflet" (onCloseLeaflet)="onCloseLeaflet($event)"></app-leaflet-map>
</ng-container>
